import React, { useState } from 'react'
import moment from 'moment'
import { orderBy } from 'lodash'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import { Popover, OverlayTrigger, Form } from 'react-bootstrap'
import { translate } from 'locales'

// Components
import { Button } from 'components'

// Styles
import * as S from './styles'
import 'bootstrap/dist/css/bootstrap.min.css'

// Utils
import { getTimes } from './utils'

// Services
import {
  handleSaveScheduleConfiguration,
  handleDeleteSchedule,
} from './services'

const OverlayConfig = ({
  info,
  occupations,
  selectedOccupation,
  setSelectedOccupation,
  country,
  selectedCountry,
  setSelectedCountry,
  handleOccupationSelection,
  handleCountrySelection,
  newSchedule,
  setNewSchedule,
  doctorSchedule,
  setDoctorSchedule,
  setLoading,
}: any) => {
  const day = moment(info?.event.startStr).format('YYYY-MM-DD')
  const [repeatSchedule, setRepeatSchedule] = useState(false)
  const locales = window.localStorage.getItem('@StarBem:lang')

  const locale = locales === 'en' ? 'en-us' : 'pt-br'
  const interval =
    selectedOccupation.slug === 'clinico-geral'
      ? 60
      : selectedOccupation?.attendance_time || 30

  const verifyLangs = () => {
    const en = info?.event?.extendedProps?.occupation?.language?.includes('CA')
    const pt = info?.event?.extendedProps?.occupation?.language?.includes('BR')
    const hasCountries = `(${en ? translate('schedule.english') : ''}${pt && en ? ', ' : ''}${
      pt ? translate('schedule.portuguese') : ''
    })`

    return `${hasCountries}`
  }

  return (
    <OverlayTrigger
      trigger="click"
      placement="auto-start"
      defaultShow={info?.event?.extendedProps.status === 'pendent'}
      rootClose
      overlay={
        info?.event?.extendedProps.status === 'pendent' ? (
          <S.PopverContainer>
            <Popover.Title as="h3">
              {`${moment
                .utc(info?.event.startStr)
                .locale(locale)
                .format('dddd, DD/MM')} - ${translate('schedule.of')} ${moment
                .utc(info?.event.startStr)
                .locale(locale)
                .format('HH:mm')} ${translate('schedule.at')} ${moment
                .utc(info?.event.endStr)
                .locale(locale)
                .format('HH:mm')}`}
            </Popover.Title>
            <Popover.Content>
              <h4>{translate('schedule.initAt')}</h4>
              <Form.Control
                as="input"
                value={moment
                  .utc(info?.event.startStr)
                  .locale('pt-br')
                  .format('HH:mm')}
                custom
                disabled
              />

              <h4>{translate('schedule.endAt')}</h4>
              <Form.Control
                as="select"
                value={newSchedule.end}
                custom
                onChange={(e) =>
                  setNewSchedule({ ...newSchedule, end: e.target.value })
                }
              >
                {getTimes(
                  moment
                    .utc(info?.event.startStr)
                    .format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
                  interval
                ).map((time) => (
                  <option key={time} value={`${day}T${time}:00Z`}>
                    {time}
                  </option>
                ))}
              </Form.Control>

              <h4>{translate('schedule.occupationArea')}</h4>

              {occupations && (
                <Form.Control
                  as="select"
                  value={selectedOccupation.id}
                  custom
                  onChange={(e) => handleOccupationSelection(e)}
                >
                  <option disabled>Selecionar</option>
                  {orderBy(occupations, ['areaName'], ['asc'])?.map(
                    (area: any) => (
                      <option key={area.id} value={area.id}>
                        {area.name}
                      </option>
                    )
                  )}
                </Form.Control>
              )}
              <div className="form-checkbox" key="scheduleRepetition">
                <label htmlFor="scheduleRepetition" className="group-checkbox">
                  <input
                    id="scheduleRepetition"
                    checked={repeatSchedule}
                    type="checkbox"
                    onChange={() => setRepeatSchedule(!repeatSchedule)}
                  />
                  {translate('schedule.recurrence')}
                </label>
              </div>

              {['psicologo'].includes(selectedOccupation.slug) && (
                <>
                  <h4>{translate('schedule.country')}</h4>
                  {country && (
                    <Form>
                      {country.includes('BR') && (
                        <Form.Check
                          inline
                          label={translate('schedule.portuguese')}
                          checked={selectedCountry.includes('BR')}
                          onChange={handleCountrySelection}
                          name="country"
                          type="checkbox"
                          id="BR"
                        />
                      )}
                      {country.includes('CA') && (
                        <Form.Check
                          inline
                          label={translate('schedule.english')}
                          checked={selectedCountry.includes('CA')}
                          onChange={handleCountrySelection}
                          name="country"
                          type="checkbox"
                          id="CA"
                        />
                      )}
                    </Form>
                  )}
                </>
              )}

              <>
                <h4>{translate('schedule.attendanceFormat')}</h4>
                <p>{translate('schedule.attendance')}</p>
              </>
              <Button
                type="button"
                color="primary"
                size="small"
                className="buttonHighlight"
                disabled={
                  ['psicologo'].includes(selectedOccupation.slug) &&
                  !selectedCountry.includes('CA') &&
                  !selectedCountry.includes('BR')
                }
                onClick={() =>
                  handleSaveScheduleConfiguration(
                    occupations,
                    selectedOccupation,
                    setSelectedOccupation,
                    country,
                    selectedCountry,
                    setSelectedCountry,
                    newSchedule,
                    setNewSchedule,
                    doctorSchedule,
                    setDoctorSchedule,
                    setLoading,
                    repeatSchedule
                  )
                }
              >
                {translate('schedule.save')}
              </Button>

              <div className="button-cancel-schedule">
                <button type="submit" onClick={() => setNewSchedule({})}>
                  {translate('schedule.cancel')}
                </button>
              </div>
            </Popover.Content>
          </S.PopverContainer>
        ) : (
          <S.PopverContainer>
            <Popover.Title as="h3">
              {translate('schedule.appointment')}
            </Popover.Title>
            <Popover.Content>
              <h4>
                <h4>
                  {moment
                    .utc(info.event.startStr)
                    .locale('pt-br')
                    .format('dddd, DD/MM')}
                </h4>
                <span
                  style={{
                    display: 'block',
                    marginTop: 12,
                    fontWeight: 'normal',
                  }}
                >
                  {`Das ${moment
                    .utc(info.event.startStr)
                    .locale('pt-br')
                    .format('HH:mm')} às ${moment
                    .utc(info.event.endStr)
                    .locale('pt-br')
                    .format('HH:mm')}`}
                </span>
              </h4>

              <Button
                type="button"
                color="danger"
                size="small"
                className="buttonHighlight"
                onClick={() =>
                  handleDeleteSchedule(
                    info?.event.id,
                    info?.event.extendedProps.plans,
                    doctorSchedule,
                    setDoctorSchedule,
                    setLoading
                  )
                }
              >
                {translate('schedule.remove')}
              </Button>
            </Popover.Content>
          </S.PopverContainer>
        )
      }
    >
      <S.EventContent>
        <p>
          {info?.event && info.event.extendedProps.status === 'confirmed' ? (
            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                }}
              >
                <div
                  style={{ display: 'flex' }}
                  title={info?.event?.extendedProps.occupation.name}
                >
                  {String(info?.event?.extendedProps.occupation.name).slice(
                    0,
                    10
                  )}
                </div>

                <DeleteOutlineIcon style={{ fontSize: 20 }} />
              </div>
              {info?.event?.extendedProps.occupation.name === 'Psicologia' && (
                <div>{verifyLangs()}</div>
              )}
              {info?.event?.extendedProps.plans?.includes('Plantão') && (
                <div style={{ fontSize: '10px', marginTop: -1 }}>
                  {translate('schedule.attendancePlantão')}
                </div>
              )}
            </div>
          ) : (
            translate('schedule.notTitle')
          )}
        </p>
      </S.EventContent>
    </OverlayTrigger>
  )
}

export default OverlayConfig
